import CountryModel from "./PhoneInput.model";

export const getCountryCodes = (countries: CountryModel[]): string[] => countries.map(country => country.codeIso2.toLowerCase());

export const getCountryLocalizations = (
  countries: CountryModel[]
): { [key: string]: string } => {
  return countries.reduce((localization, country) => {
    return { ...localization, [country.codeIso2.toLowerCase()]: country.name };
  }, {});
};
